import angular from 'angular';
import template from './talentExpertHiringFunnelCandidateView.html';

export class TalentExpertHiringFunnelCandidateComponent {
    /* @ngInject */
    constructor() {
        const talentExpertHiringFunnelCandidateCtrl = this;
        talentExpertHiringFunnelCandidateCtrl.init = function () {

        };

        talentExpertHiringFunnelCandidateCtrl.init();
    }
}

export const TalentExpertHiringFunnelCandidateComponentConfiguration = {
    template,
    controller: TalentExpertHiringFunnelCandidateComponent,
    controllerAs: 'talentExpertHiringFunnelCandidateCtrl',
};

angular
    .module('TALENYA-FE')
    .component('talentExpertHiringFunnelCandidateComponent', TalentExpertHiringFunnelCandidateComponentConfiguration);
